// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1B4nQ","ranges":"BmiRanges_ranges__36l5Q"};